import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleToggleCollapsed,
  handleSetSelectedSentimentValues,
  handleChangeSortBy,
  handleSetSelectedFilterIds,
  handleSetSelectedFilterValue,
} from 'store/helpers/filterHelpers';
import { handleApplySettingsFilters } from './contentHelpers';
import { instagramCommentFiltersInitialState } from './initialState/instagramCommentByCommentInitialState';

export { instagramCommentFiltersInitialState as filtersInitialState };

export const instagramCommentByCommentContentInitialState = {
  filters: instagramCommentFiltersInitialState,
  sortBy: {
    selected: 'time',
    order: 'desc',
  },
  selectedFilter: 'contentTagFilter',
};
export const instagramCommentByCommentContentSlice = createSlice({
  name: 'instagramCommentByCommentContentSlice',
  initialState: instagramCommentByCommentContentInitialState,
  reducers: {
    setSelectedFilterIds: (state, action) => {
      handleSetSelectedFilterIds(state, action);
    },
    setSelectedSentimentValues: (state, action) => {
      handleSetSelectedSentimentValues(state, action);
    },
    changeSortBy: (state, action) => {
      handleChangeSortBy(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = instagramCommentFiltersInitialState;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, instagramCommentFiltersInitialState);
    },
    applyWebsiteSettingsFilters: (state, action) => {
      handleApplySettingsFilters(state, action);
    },
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(
        state,
        action,
        instagramCommentFiltersInitialState
      );
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
  },
});

export const {
  setSelectedFilterIds,
  setSelectedItems,
  toggleCollapsed,
  resetAllFilters,
  resetFilter,
  setSelectedSentimentValues,
  changeSortBy,
  applyWebsiteSettingsFilters,
  setSelectedFilter,
  setSelectedFilterValue,
} = instagramCommentByCommentContentSlice.actions;
